import { AxiosError, AxiosResponse } from 'axios';
import { useState } from 'react'
import { useDispatch } from 'react-redux'

import { SuccessCode } from '@const/consts'

import { resetModal } from '@store/modules/modal';

import { displayErrorNotification, displaySuccessNotification } from '@utils/utils'

import { IAxiosErrorData } from '@services/types';
import { IHandlerFetchRequestProps, IUseLoadingArgs, UseLoading } from '@hooks/types';

export const useLoading = <T, P>({ fetchRequest, notification, isCloseModal = true }: IUseLoadingArgs<T, P>): UseLoading<T> => {
  const [loading, setLoading] = useState<boolean>(false)

  const dispatch = useDispatch()

  const handlerFetchRequest = (params: IHandlerFetchRequestProps<T>): void => {
    const { callback, errorCallback, data } = params

    const handlerSetLoading = (newValue: boolean, isCloseModal?: boolean): void => {
      if (isCloseModal) dispatch(resetModal)

      const timeout = newValue ? 0 : 500

      setTimeout(() => setLoading(newValue), timeout)
    }

    handlerSetLoading(true)

    fetchRequest(data)
      .then((resp: AxiosResponse) => {
        const method = resp.config.method?.toUpperCase()

        if (method) {
          const isCheckCode = Array.isArray(SuccessCode[method]) ?
            SuccessCode[method].includes(resp.status) :
            SuccessCode[method] === resp.status

          if (isCheckCode) {
              notification &&
                displaySuccessNotification({
                  title: notification.title,
                  content: notification.content
                })

            handlerSetLoading(false, isCloseModal)
            callback?.(resp)
          }
        }
      })
      .catch((error: AxiosError<IAxiosErrorData>) => {
        displayErrorNotification(error)
        errorCallback?.(error)
        handlerSetLoading(false)
      })
  }

  return [
    loading,
    handlerFetchRequest
  ]
}
